import { Entry } from 'contentful'
import { mapContentfulImageAsset } from '@utils/contentful/contentfulImage'
import { IContentfulConfigurableTileEntry } from 'types/contentful/configurableTile.types'
import { IContentfulConfigurableCard } from 'types/contentful/configurableCard.types'

export const parseConfigurableTile = (
  configurableTile: Entry<IContentfulConfigurableTileEntry>
): IContentfulConfigurableCard => {
  const card = {
    componentKey: 'configurableTile',
    name: configurableTile?.fields?.name,
    cardType: configurableTile?.fields?.tileType,
    cardSize: configurableTile?.fields?.tileSize,
    cardLink: configurableTile?.fields?.tileLink,
    cardBackgroundColor: configurableTile?.fields?.tileBackgroundColor,
    image: mapContentfulImageAsset(configurableTile?.fields?.image),
    imageBackgroundColor: configurableTile?.fields?.imageBackgroundColor,
    title: configurableTile?.fields?.title,
    titleColor: configurableTile?.fields?.titleColor,
    trackingIdentifier: configurableTile?.fields?.trackingIdentifier,
  }

  return card
}
